export default "__VITE_ASSET__Dc25o04f__"